import { useState, useEffect } from "react";
import { Col, Row, Space, Form } from "antd";
import { ButtonAdd } from "components/Common/Buttons";
import ButtonAction from "components/Common/ButtonAction";
import CustomAntdTable from "components/Common/CustomAntdTable";
import { CustomFormItemText } from "components/Common/CustomFormItemVertical";
import {
  CustomFormItemTextArea
} from "components/Common/CustomFormItem";

export default function SectionWbsTask({ isView = false, form, onChangeTaskList, initialTaskList = [] }) {
  const [taskList, setTaskList] = useState([]);


  const handleAddRow = () => {
    const updated = [
      ...taskList,
      {
        id: Date.now(),
        taskDescription: "",
        remark: "",
      },
    ];
    setTaskList(updated);
    onChangeTaskList?.(updated);
  };

  const handleDeleteRow = (id) => {
    const updated = taskList.filter((item) => item.id !== id);
    setTaskList(updated);
    onChangeTaskList?.(updated);
  };

  const onChangeInput = (id, field, value) => {
    const updated = taskList.map((item) =>
      item.id === id ? { ...item, [field]: value } : item
    );
    setTaskList(updated);
    onChangeTaskList?.(updated);
  };

  const columns = [
    {
      title: "No",
      dataIndex: "no",
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Uraian Tugas",
      dataIndex: "taskDescription",
      render: (_, row) => (
        <CustomFormItemTextArea
          nameFormItem={`taskDescription_${row.id}`}
          value={row.taskDescription}
          wrapperCol={10}
          labelCol={12}
          styleInput={{
            width: 450,
            minHeight: 50,
            maxHeight: 200,
            overflow: 'hidden',
            resize: 'none', // agar auto expand tidak terganggu manual resize
            fontSize: 13,
            lineHeight: 1.4,
            padding: '8px 10px',
          }}
          autoSize={{ minRows: 2, maxRows: 8 }} // ✅ ini penting!
          rows={3} // masih aman untuk default
          onChange={(e) => onChangeInput(row.id, "taskDescription", e.target.value)}
          useInTable
        />
       
      ),
    },
    {
      title: "Remark",
      dataIndex: "remark",
      render: (_, row) => (
        <CustomFormItemTextArea
          nameFormItem={`remark_${row.id}`}
          value={row.taskDescription}
          wrapperCol={10}
          labelCol={12}
          styleInput={{
            width: 450,
            minHeight: 50,
            maxHeight: 200,
            overflow: 'hidden',
            resize: 'none', // agar auto expand tidak terganggu manual resize
            fontSize: 13,
            lineHeight: 1.4,
            padding: '8px 10px',
          }}
          autoSize={{ minRows: 2, maxRows: 8 }} // ✅ ini penting!
          rows={3} // masih aman untuk default
          onChange={(e) => onChangeInput(row.id, "remark", e.target.value)}
          useInTable
        />
       
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 60,
      render: (_, row) => (
        <ButtonAction buttons={["delete"]} onDelete={() => handleDeleteRow(row.id)} />
      ),
    },
  ];

  useEffect(() => {
    if (Array.isArray(initialTaskList) && initialTaskList.length > 0) {
      const normalized = initialTaskList.map((item, index) => {
        const taskDescription = item.taskDescription ?? item.wbsContentTask ?? '';
        const remark = item.remark ?? item.wbsContentRemark ?? '';

        return {
          id: item.id || item.wbsContentId || `${Date.now()}-${index}`,
          taskDescription,
          remark
        };
      });

      setTaskList(normalized);

      // 🔥 Tambahkan nilai ke form
      const formValues = {};
      normalized.forEach(row => {
        formValues[`taskDescription_${row.id}`] = row.taskDescription;
        formValues[`remark_${row.id}`] = row.remark;
      });
      form.setFieldsValue(formValues);
    }
  }, [initialTaskList]);






  return (
    <div>
      <Space className="mb-2">
        {!isView && <ButtonAdd onClick={handleAddRow} buttonText="Add Uraian Tugas" />}
      </Space>
      <CustomAntdTable
        columns={columns}
        dataSource={taskList}
        rowKey="id"
        pagination={false}
      />
    </div>
  );
}

